<template>
  <body id="app">
    <Header
      :logoAlt="logoAlt"

      :dataDia="dataDia"
      :dataMes="dataMes"

      :horaInicio="horaInicio"
      :horaFim="horaFim"

      :localPais="localPais"
      :localEstado="localEstado"
      :localCidade="localCidade"
      :localLocal="localLocal"
      :localEspecifico="localEspecifico"

      :menu="menu"

      :stylesMenu="stylesMenu"

      :stylesDataDia="stylesDataDia"
      :stylesDataMes="stylesDataMes"

      :stylesHora="stylesHora"

      :stylesLocal="stylesLocal"
      :stylesLocalEspecifico="stylesLocalEspecifico"
    />

    <div class="grad">

      <carousel
        class="carousel__first"
        :autoplay="true"
        :autoplayHoverPause="true"
        :autoplayTimeout="5000"
        :speed="1000"
        :perPage="1"
        :loop="true"
        :navigationEnabled="true"
      >

        <slide>
          <a
            href="#sobre"
            class="slide__container"
            style="background-image: url('./images/destaques/dez-anos.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="https://www.facebook.com/events/2486203568290440/"

            target="_blank"

            class="slide__container"
            style="background-image: url('./images/destaques/evento-fb.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#apresentacoes"
            class="slide__container"
            style="background-image: url('./images/destaques/bucaneiros.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#apresentacoes"
            class="slide__container"
            style="background-image: url('./images/destaques/mare-nostrum.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#chronos-fest"
            class="slide__container"
            style="background-image: url('./images/destaques/chronos.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#swordplay"
            class="slide__container"
            style="background-image: url('./images/destaques/swordplay.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#caca-ao-tesouro"
            class="slide__container"
            style="background-image: url('./images/destaques/cat-adu.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#caca-ao-tesouro"
            class="slide__container"
            style="background-image: url('./images/destaques/cat-inf.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#pirata-do-ano"
            class="slide__container"
            style="background-image: url('./images/destaques/pda-indicados.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#concursos"
            class="slide__container"
            style="background-image: url('./images/destaques/figurinos.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>

        <slide>
          <a
            href="#footer"
            class="slide__container"
            style="background-image: url('./images/destaques/cat-site.jpg');"
            v-smooth-scroll
          >
          </a>
        </slide>
      </carousel>

      <Section
        sectionId="programacao"
        sectionTitle="Programação"
        topLink="#header"
      >
        <p>
          <ul class="li-col">
            <li>
              <strong>11:00</strong> <br />
              - Início
            </li>
            <li>
              <strong>14:00</strong> <br />
              - Caça ao Tesouro Infantil
            </li>
            <li>
              <strong>15:00</strong> <br />
              - Caça ao Tesouro Adulto
            </li>
            <li>
              <strong>16:00</strong> <br />
              - Apresentação da banda Bucaneiros do Sétimo Mar
            </li>
            <li>
              <strong>16:00</strong> <br />
              - Apresentação da Mare Nostrum Shanty Crew
            </li>
            <li>
              <strong>18:00</strong> <br />
              - Encerramento
            </li>
            <li>
              <strong>O dia todo</strong> <br />
              - Chronos Fest <br />
              - Swordplay com a Alcateia
            </li>
          </ul>
        </p>
      </Section>

      <Section
        sectionId="sobre"
        sectionTitle="Sobre"
        topLink="#header"
      >
        <h3>
          Ahoy Piratas!
        </h3>

        <p>
          Está chegando a nossa mais querida data, dia <strong>19 de setembro,</strong> também conhecida como o <strong>Dia Internacional De Falar Como Um Pirata.</strong> A data é conhecida no território nacional como <strong>Dia do Pirata</strong> ou <strong>Pirate Day</strong>. Este ano, a data oficial cai numa quinta-feira, o que não vai nos impedir de comemorar. Muitos piratas trabalham na quinta (não, nós não vivemos apenas de pirataria), então para ir trabalhar com estilo e já relaxado e feliz, a comemoração será no fim de semana, dia <strong>22 de Setembro, domingo.</strong>
        </p>

        <p>
          Esse ano o nosso evento é ainda mais especial! <strong>O PirateDay 2019 é o 10º #PirateDay organizado pela Aliança Pirata</strong>, sendo o 14º PirateDay organizado no Brasil. São 10 anos de muitas aventuras, e por isso teremos alguns diferenciais nessa edição do nosso piquenique.
        </p>

        <p>
          Este ano vamos ancorar no <strong>Parque da Água Branca</strong>. Para chegar ao local do nosso encontro basta pagar uma taxa ao navio de algum mercador (metrô, ônibus ou uber) ou levar seu próprio navio ate o local.
        </p>

        <p>
          Lá podemos realizar as atividades com maior segurança em uma área grande que comporta todos os confrades. Como todos sabem, o evento é colaborativo, aberto para todos e é de todos! A <strong>ALIANÇA PIRATA</strong> procura sempre acolher todos e tornar esses pequenos momentos inesquecíveis!
        </p>
      </Section>

      <Section
        sectionId="fotos"
        sectionTitle="Fotos"
        topLink="#header"
      >
        <h3>
          2014
        </h3>
        <lightbox
          class="lightbox__container"
          :images="quatorze"
          :resetstyles="true"
        ></lightbox>

        <h3>
          2015
        </h3>
        <lightbox
          class="lightbox__container"
          :images="quinze"
          :resetstyles="true"
        ></lightbox>

        <h3>
          2016
        </h3>
        <lightbox
          class="lightbox__container"
          :images="dezesseis"
          :resetstyles="true"
        ></lightbox>

        <h3>
          2017
        </h3>

        <lightbox
          class="lightbox__container"
          :images="dezessete"
          :resetstyles="true"
        ></lightbox>

        <h3>
          2018
        </h3>
        <lightbox
          class="lightbox__container"
          :images="dezoito"
          :resetstyles="true"
        ></lightbox>
      </section>

      <Section
        sectionId="apresentacoes"
        sectionTitle="Apresentações"
        topLink="#header"
      >
        <h3>Bucaneiros do Sétimo Mar</h3>

        <div class="columns">
          <div class="col-2">
            <p>
              Bucaneiros do Sétimo Mar, banda do ABC Paulista. Possuem um som único, é difícil definir as misturas que a banda escolheu, mesmo que haja uma clara referência de Confraria da Costa, eles vão além. Prometem passar por diversos estilos musicais, sem perder a essência pirata.
            </p>

            <p>
              Banda formada em Novembro de 2016, contando com músicos incríveis e cheios de boas histórias para contar.
            </p>

            <p>
              <ul>
                <li>
                  Salomão - Voz/Violão
                </li>
                <li>
                  Amadeus - Violino/Violão
                </li>
                <li>
                  Blacktyde - Guitarra/Voz
                </li>
                <li>
                  Pascoal - Sax
                </li>
                <li>
                  Cacique Bincho - Bateria
                </li>
                <li>
                  Duncan - Baixo
                </li>
              </ul>
            </p>

          </div>

          <div class="col-2">
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/tZ9sNKgGoX8"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            >
            </iframe>

            <p>
              <a href="https://www.youtube.com/channel/UCldjARRczkXbB-ebIkCKcgQ">
                &nbsp;&nbsp;Youtube&nbsp;&nbsp;
              </a>
              
              <a href="https://www.facebook.com/bucaneiros7mar">
                &nbsp;&nbsp;Facebook&nbsp;&nbsp;
              </a>

              <a href="https://www.instagram.com/bucaneiros7mar/">
                &nbsp;&nbsp;Instagram&nbsp;&nbsp;
              </a>
            </p>
          </div>
          
        </div>

        <h3>Mare Nostrum Shanty Crew</h3>

        <div class="columns">
          <div class="col-2">
            <p>
              O shanty crew Mare Nostrum começou como um trabalho de conclusão de semestre da disciplina de técnica vocal do curso de licenciatura em música da Faccamp, ministrada pela professora Nani Barbosa. Decidindo dar continuidade ao trabalho, foi criado um grupo de estudos sobre sea shanties e canções tradicionais entre os alunos.
            </p>

            <p>
              O grupo começou com Diego Prestes, Paula Pinheiro, Rodrigo Lucc, Vinicius Soares, Guilherme Barreto, Bárbara Sanches e Lucca Filippo, posteriormente entraram Giulia Katherine, Pedro Henrique e Sofia Nasar.
            </p>

            <p>
              A formação atual conta com:  
            </p>

            <p>
              <ul>
                <li>
                  Diego Prestes
                </li>
                <li>
                  Vinicius Soares
                </li>
                <li>
                  Sofia Nasar
                </li>
                <li>
                  Pedro Henrique
                </li>
              </ul>
            </p>

          </div>

          <div class="col-2">
            <video width="100%" controls="">
              <source src="./videos/mare-nostrum-shanty-crew.mp4" type="video/mp4">
              Seu Browser não suporta vídeos
            </video>

            <p>
              <a href="https://www.facebook.com/Marenostrumcrew/">
                &nbsp;&nbsp;Facebook&nbsp;&nbsp;
              </a>
            </p>
          </div>
          
        </div>
      </Section>

      <Section
        sectionId="swordplay"
        sectionTitle="Swordplay"
        topLink="#header"
      >
        <h3>Alcateia</h3>

        <p>
          Num passado não tão distante tivemos a participação de um grupo de duelos chamado Alcateia Swordplay.
        </p>

        <p>
          Este ano o grupo estará novamente no PirateDay, mais uma vez liderado pelo pelo Leandro de Andrade.
        </p>

        <p>
          Querem o contato deles? <a href="https://wa.me/5511988121350" target="_blank">basta clicar aqui!</a>
        </p>

        <lightbox
          class="lightbox__container"
          :images="swordplay"
          :resetstyles="true"
        ></lightbox>
      </Section>

      <Section
        sectionId="caca-ao-tesouro"
        sectionTitle="Caça ao Tesouro"
        topLink="#header"
      >
        <p>
          <img src="./images/section/caca/cat-infantil.jpg" alt="Caça ao Tesouro - Infantil" class="left">
        </p>

        <p>
          Quem conhece nossos eventos, sabe que gostamos muito de fazer vocês correrem pelo parque em busca das nossas queridas <strong>PISTAS</strong>, desvendando algumas charadas para ganhar o <strong>TESOURO</strong>. Garantimos que os prêmios são sempre legais. Raramente você volta para casa de mãos (ou ganchos) vazias!
        </p>

        <p>
          Nos últimos anos organizamos dois <strong>CAÇAS AO TESOURO</strong>, uma só para as crianças e outra só para os adultos, assim as coisas ficam mais justas.
        </p>

        <p>
          O inicio do Caça ao Tesouro das <strong>CRIANÇAS</strong> será <strong>14:00h</strong>. Crianças até 12 anos podem participar. O Caça ao Tesouro dos <strong>ADULTOS</strong> será <strong>15:00h</strong>.
        </p>

        <p>
          Para participar basta juntar um grupo de no minimo <strong>4 PESSOAS</strong> e estar pronto quando a organização do evento chamar! Os participantes devem estar na parte onde realizamos nosso piquenique e só poderão sair do local após dada a <strong>PRIMEIRA PISTA</strong>. No Caça ao Tesouro infantil, todas as crianças participam juntas!
        </p>

        <p>
          Para ganhar os prêmios, os grupos devem completar todas as etapas e apresentar todas as pistas da caçada. Teremos premiação para os primeiro, segundo e terceiro lugares. Para as crianças, todas levam o prêmio para casa, <a href="https://www.facebook.com/AliancaPirata/photos/a.319105174786886/2840956622601716/" target="_blank">por isso é importante que os responsaveis confirmem a participação de seus piratinhas na imagem oficial do evento</a>. Eai? Vai perder esta? Claro que não! Boa sorte Marujos!
        </p>

        <p>
          <video width="100%" controls="">
            <source src="./videos/cat-adu.mp4" type="video/mp4">
            Seu Browser não suporta vídeos
          </video>
        </p>

      </Section>

      <Section
        sectionId="chronos-fest"
        sectionTitle="Chronos Fest"
        topLink="#header"
      >
        <div class="columns">
          <img src="images/section/chronos/chronosfest.jpg" alt="Chronos Fest" class="left">

          <div>
            <p>
              Rivalidade entre grupos sempre existiu e alguns grupos que organizam eventos de temáticas diferentes se uniram para criar o <strong>Chronos Fest</strong>, que é uma espécie de Olimpíada com jogos diversos, baseados em períodos e culturas diversos do tempo.
            </p>

            <p>
              A ideia de <strong>Chronos Fest</strong> é justamente mostrar quem é o melhor, fazendo cada um dar tudo de si para vencer os desafios. A iniciativa já deu as caras em diversos eventos e estará também no <strong>Pirate Day 2019.</strong>
            </p>

            <p>
              E claro, não podemos esquecer que o <strong>Chronos Fest</strong> é organizado pelo <a href="https://www.facebook.com/palcopirata/" target="_blank">Palco Pirata</a>, piratas de Caieiras que formaram um coletivo cultural que realiza eventos esporádicos com música, teatro, dança, artes visuais e outras atividades culturais.
            </p>

            <p>
              Nós, Piratas, desafiamos vocês para os jogos!<br />
              Vai encarar?
            </p>
          </div>
        </div>
      </Section>

      <Section
        sectionId="concursos"
        sectionTitle="Concursos"
        topLink="#header"
      >

        <h3>Figurinos</h3>

        <p>
          <img src="./images/section/concursos/fig.jpg" alt="Concursos de melhor figurino">
        </p>

        <p>
          Como tradição em nossos eventos e uma maneira de incentivar as pessoas a criarem seus figurinos piratas e usarem os mesmos em nossos piqueniques temos a premiação para <strong>MELHOR FIGURINO PIRATA MASCULINO E FEMININO</strong>, <strong>MELHOR FIGURINO DE SEREIAS</strong> e uma novidade neste ano, o <strong>MELHOR FIGURINO VITORIANO</strong>.
        </p>

        <p>
          Para concorrer basta estar devidamente piratizado, vitorianizado ou sereiado no piquenique. Durante o evento 06 pessoas escolhidas pelos representantes da Aliança são chamados para participar, estes representantes vão dar aos concorrentes um objeto que simboliza o voto. A pessoa que ganhar mais votos vence. Caso empate entre duas ou mais pessoas, sera feito uma votação popular para desempate.
        </p>
      </Section>

      <Section
        sectionId="pirata-do-ano"
        sectionTitle="Pirata do Ano"
        topLink="#header"
      >
        <p>
          Todo o ano, <strong>TODO E QUALQUER PIRATA QUE JÁ VEIO, PARTICIPOU E AJUDOU DE ALGUMA FORMA</strong> nos eventos da Aliança Pirata (sejam estes eventos organizados pela Aliança Pirata e/ou que a Aliança Pirata fez alguma participação) pode concorrer como <strong>PIRATA DO ANO</strong>.
        </p>

        <p>
          Neste ano as indicações serão feitas pela Naga Riddle, que vai avaliar diversos critérios sobre os piratas indicados.
        </p>

        <p>
          <a href="https://www.facebook.com/PirateDayBrasil/photos/ms.c.eJxFj8ENBDEIAzs6xRhI3H9jq4MN~_x2NxjII84DDLDNoPxQw8A881wvgWYbtC8QjEp4X7FUgdRsrC5DXCFUDPg11Y1bC29BET0cx0V7hGBkF9hf1COng~_9KGjeHdkB5QdzLx.bps.a.1312451355599871/1312451412266532/?type=3&theater">
            Foi criado um álbum com os concorrentes, 
          </a>

          <strong>os 3 que receberem mais likes na foto, até a data do evento</strong>, entram pras finais. 
        </p>

        <p>
          Durante o <strong>Pirate Day 2019</strong> haverá a votação popular para selecionar o vencedor, que levará o troféu de <strong>Pirata do Ano 2019</strong>.
        </p>

        <h3>Seguem os indicados</h3>

        <lightbox
          class="lightbox__container pirata-do-ano"
          :images="pda"
          :resetstyles="true"
        ></lightbox>

        <p>
          Não foi indicado? Faça por merecer. Compareça aos eventos, ajude na organização, colabore da forma que puder. Trabalhe como um Capitão, Divirta-se como um verdadeiro Pirata.
        </p>
      </Section>

      <Section
        sectionId="livre-comercio"
        sectionTitle="Livre Comércio"
        topLink="#header"
      >

        <p>
          <img src="images/section/livrecomercio/lc.jpg" alt="Pirate Day de 2019 | Mapa do Local" class="image-responsive">
        </p>
        <p>
          O <strong>LIVRE COMÉRCIO</strong> é um hábito em todos os nossos eventos, onde amigos e conhecidos, que possuem algum tipo de loja expõe alguns itens que podem ser vendidos ou trocados durante o evento.
        </p>
        
        <p>
          O <strong>parque não permite tal atividade</strong>, então se for fazer algum tipo de venda ou troca, faça por sua conta e risco. Não nos responsabilizamos por quaisquer problemas que venham a acontecer.
        </p>
        
        <p>
          <strong>LEMBRANDO TAMBÉM QUE ESTE NÃO É O FOCO DO EVENTO</strong> e que possuímos um evento mercantilista para estes fins. Essa é somente uma maneira de ajudar aos amigos e conhecidos a divulgar seus trabalhos.
        </p>
      </Section>

      <Section
        sectionId="faq"
        sectionTitle="FAQ"
        topLink="#header"
      >
        <p>
          Como muitas pessoas não costumam ler as coisas, e mesmo com a informação na cara, fazem perguntas, foi criada esta sessão. Tem ali embaixo um filtro para buscar por sua palavra-chave. Boa busca!
        </p>

        <Faq :faqQuestions="faqQuestions"></Faq>

      </Section>

      <Section
        sectionId="local"
        sectionTitle="Local"
        topLink="#header"
      >
        <h3>Parque da Água Branca</h3>
        <p>
            <strong>Endereço: </strong> Avenida Francisco Matarazzo, 455 | Barra Funda - São Paulo - SP - CEP: 05001-900 <br />
            <strong>Funcionamento: </strong> De segunda a segunda, das 6 às 22h <br />
            <strong>Mais informações: </strong> <a href="http://parqueaguabranca.sp.gov.br/" target="_blank">parqueaguabranca.sp.gov.br/</a>
        </p>

        <img src="images/section/local/mapa.jpg" alt="Pirate Day de 2019 | Mapa do Local" class="image-responsive">

        <h3>Estrutura</h3>
        <p>
            <strong>Estacionamento:</strong> Gratuito, possui 70 vagas e fica localizado próximo a portaria da Rua Dona Ana Pimentel. <br />
            <strong>Sanitários:</strong> Um sanitário infantil e um fraldário nas proximidades do playground e sanitários masculinos e femininos (adaptados), próximo ao prédio da administração. <br />
            <strong>Acessibilidade</strong> Sanitários adaptados para pessoas com deficiência, vagas especiais demarcadas nos estacionamentos, rampas e acesso a toda a área do parque.
        </p>

        <h3>Como chegar?</h3>
        <p>
            O Parque da Água Branca está localizado na avenida Francisco Matarazzo, a apenas 800 metros do Metrô Barra Funda.
        </p>

        <video width="100%" controls="">
          <source src="./videos/como-chegar.mp4" type="video/mp4">
          Seu Browser não suporta vídeos
        </video>
      </Section>

      <Section
        sectionId="contato"
        sectionTitle="Contato"
        topLink="#header"
      >
        <div class="fb-blocks">
          <div class="fb-block fb-page fb_iframe_widget" data-href="https://www.facebook.com/AliancaPirata/" data-tabs="timeline" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true" fb-xfbml-state="rendered" fb-iframe-plugin-query="adapt_container_width=true&amp;app_id=&amp;container_width=465&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FAliancaPirata%2F&amp;locale=pt_BR&amp;sdk=joey&amp;show_facepile=true&amp;small_header=true&amp;tabs=timeline&amp;">
            <span style="vertical-align: bottom;">
              <iframe name="ff3dea62856c5" title="fb:page Facebook Social Plugin" frameborder="0" allowtransparency="true" allowfullscreen="true" scrolling="no" allow="encrypted-media" src="https://www.facebook.com/v2.7/plugins/page.php?adapt_container_width=true&amp;app_id=&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter.php%3Fversion%3D44%23cb%3Df17d9d228dca84c%26domain%3Dpirateday.com.br%26origin%3Dhttp%253A%252F%252Fpirateday.com.br%252Ff2f03cfedf63ad4%26relation%3Dparent.parent&amp;container_width=465&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FAliancaPirata%2F&amp;locale=pt_BR&amp;sdk=joey&amp;show_facepile=true&amp;small_header=true&amp;tabs=timeline&amp;" style="border: none; visibility: visible; height: 500px;" class=""></iframe>
            </span>
          </div>

          <div class="fb-block fb-page fb_iframe_widget" data-href="https://www.facebook.com/PirateDayBrasil/" data-tabs="timeline" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true" fb-xfbml-state="rendered" fb-iframe-plugin-query="adapt_container_width=true&amp;app_id=&amp;container_width=465&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FPirateDayBrasil%2F&amp;locale=pt_BR&amp;sdk=joey&amp;show_facepile=true&amp;small_header=true&amp;tabs=timeline&amp;">
            <span style="vertical-align: bottom;">
              <iframe name="f3776e8da6db40c" title="fb:page Facebook Social Plugin" frameborder="0" allowtransparency="true" allowfullscreen="true" scrolling="no" allow="encrypted-media" src="https://www.facebook.com/v2.7/plugins/page.php?adapt_container_width=true&amp;app_id=&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter.php%3Fversion%3D44%23cb%3Df157dd59b33c34%26domain%3Dpirateday.com.br%26origin%3Dhttp%253A%252F%252Fpirateday.com.br%252Ff2f03cfedf63ad4%26relation%3Dparent.parent&amp;container_width=465&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FPirateDayBrasil%2F&amp;locale=pt_BR&amp;sdk=joey&amp;show_facepile=true&amp;small_header=true&amp;tabs=timeline&amp;" style="border: none; visibility: visible; height: 500px;" class=""></iframe>
            </span>
          </div>
        </div>
      </Section>

      <Footer id="footer"></Footer>

    </div>
  </body>
</template>

<script>
  /* External components */
  import { Carousel, Slide } from 'vue-carousel'

  /* Internal components */
  import Header from './components/Header.vue'
  import Section from './components/Section.vue'
  import Footer from './components/Footer.vue'
  import Faq from './components/Faq.vue'

  export default {
    name: 'app',
    components: {
      Carousel,
      Slide,

      Header,
      Section,
      Footer,
      Faq,
    },

    data: function() {
      return {
        // HEADER
        logoAlt: 'Pirate Day 2019',
        dataDia: '22',

        dataMes: 'Setembro',

        horaInicio: '11:00',
        horaFim: '18:00',

        localPais: 'Brasil',
        localEstado: 'SP',
        localCidade: 'São Paulo',
        localLocal: 'Parque da Água Branca',
        localEspecifico: 'Avenida Francisco Matarazzo, 455 Barra Funda',

        // MENU
        stylesMenu: 'font-size: 22px; margin-top: 0px;',

        stylesDataDia: 'font-size: 150px; margin: 20px 15px -35px 0;',
        stylesDataMes: 'font-size: 32px; margin-top: 50px;',

        stylesHora: 'font-size: 18px;',

        stylesLocal: 'font-size: 34px; margin-bottom: -15px;',
        stylesLocalEspecifico: 'font-size: 16px; margin-top: 30px;',

        menu: [
          { 
            key: '', url: '#programacao',
            text: 'Programação', target: '',
          },
          { 
            key: '', url: '#sobre',
            text: 'Sobre', target: '',
          },
          { 
            key: '', url: '#fotos',
            text: 'Fotos', target: '',
          },
          { 
            key: '', url: '#apresentacoes',
            text: 'Apresentações', target: '',
          },
          { 
            key: '', url: '#swordplay',
            text: 'Swordplay', target: '',
          },
          { 
            key: '', url: '#caca-ao-tesouro',
            text: 'Caça ao Tesouro', target: '',
          },
          { 
            key: '', url: '#chronos-fest',
            text: 'Chronos Fest', target: '',
          },
          { 
            key: '', url: '#concursos',
            text: 'Concursos', target: '',
          },
          { 
            key: '', url: '#pirata-do-ano',
            text: 'Pirata do Ano', target: '',
          },
          { 
            key: '', url: '#livre-comercio',
            text: 'Livre Comércio', target: '',
          },
          { 
            key: '', url: '#faq',
            text: 'FAQ', target: '',
          },
          { 
            key: '', url: '#local',
            text: 'Local', target: '',
          },
          { 
            key: '', url: '#contato',
            text: 'Contato', target: '',
          },
        ],

        // FOTOS
        quatorze: [
            { src: './images/section/fotos/2014/1.jpg', caption: 'Pirate Day 2014', },
            { src: './images/section/fotos/2014/2.jpg', caption: 'Pirate Day 2014', },
            { src: './images/section/fotos/2014/3.jpg', caption: 'Pirate Day 2014', },
            { src: './images/section/fotos/2014/4.jpg', caption: 'Pirate Day 2014', },
            { src: './images/section/fotos/2014/5.jpg', caption: 'Pirate Day 2014', },
        ],
        quinze: [
            { src: './images/section/fotos/2015/1.jpg', caption: 'Pirate Day 2015', },
            { src: './images/section/fotos/2015/2.jpg', caption: 'Pirate Day 2015', },
            { src: './images/section/fotos/2015/3.jpg', caption: 'Pirate Day 2015', },
            { src: './images/section/fotos/2015/4.jpg', caption: 'Pirate Day 2015', },
            { src: './images/section/fotos/2015/5.jpg', caption: 'Pirate Day 2015', },
        ],
        dezesseis: [
            { src: './images/section/fotos/2016/1.jpg', caption: 'Pirate Day 2016', },
            { src: './images/section/fotos/2016/2.jpg', caption: 'Pirate Day 2016', },
            { src: './images/section/fotos/2016/3.jpg', caption: 'Pirate Day 2016', },
            { src: './images/section/fotos/2016/4.jpg', caption: 'Pirate Day 2016', },
            { src: './images/section/fotos/2016/5.jpg', caption: 'Pirate Day 2016', },
        ],
        dezessete: [
            { src: './images/section/fotos/2017/1.jpg', caption: 'Pirate Day 2017', },
            { src: './images/section/fotos/2017/2.jpg', caption: 'Pirate Day 2017', },
            { src: './images/section/fotos/2017/3.jpg', caption: 'Pirate Day 2017', },
            { src: './images/section/fotos/2017/4.jpg', caption: 'Pirate Day 2017', },
            { src: './images/section/fotos/2017/5.jpg', caption: 'Pirate Day 2017', },
        ],
        dezoito: [
            { src: './images/section/fotos/2018/1.jpg', caption: 'Pirate Day 2018', },
            { src: './images/section/fotos/2018/2.jpg', caption: 'Pirate Day 2018', },
            { src: './images/section/fotos/2018/3.jpg', caption: 'Pirate Day 2018', },
            { src: './images/section/fotos/2018/4.jpg', caption: 'Pirate Day 2018', },
            { src: './images/section/fotos/2018/5.jpg', caption: 'Pirate Day 2018', },
        ],

        // SWORDPLAY
        swordplay: [
            { src: './images/section/swordplay/1.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/2.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/3.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/4.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/5.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/6.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/7.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/8.png', caption: 'Alcateia Swordplay', },
            { src: './images/section/swordplay/9.png', caption: 'Alcateia Swordplay', },
        ],

        // PIRATA DO ANO
        pda: [
            { src: './images/section/pda/1.jpg', caption: 'Pirata do Ano 2018 - Allison Barbosa', },
            { src: './images/section/pda/2.jpg', caption: 'Pirata do Ano 2018 - Anne De Le Veut - RCC', },
            { src: './images/section/pda/3.jpg', caption: 'Pirata do Ano 2018 - Dino - Piratas da Represa', },
            { src: './images/section/pda/4.jpg', caption: 'Pirata do Ano 2018 - Dyana Rodrigues Palma - RCC', },
            { src: './images/section/pda/5.jpg', caption: 'Pirata do Ano 2018 - Eduardo Greco - Tripulação Caveira', },
            { src: './images/section/pda/6.jpg', caption: 'Pirata do Ano 2018 - Edvandro Gomes de Sousa', },
            { src: './images/section/pda/7.jpg', caption: 'Pirata do Ano 2018 - Fernando Mohamad Von Fleckenstein Trugillo - Piratas da Represa', },
            { src: './images/section/pda/8.jpg', caption: 'Pirata do Ano 2018 - Giovanni Sonnberger - Palco Pirata', },
            { src: './images/section/pda/9.jpg', caption: 'Pirata do Ano 2018 - Jack S. Wallbaum - Confraria Jolly Roger', },
            { src: './images/section/pda/10.jpg', caption: 'Pirata do Ano 2018 - Paula Rodrigues - RCC', },
            { src: './images/section/pda/11.jpg', caption: 'Pirata do Ano 2018 - Rafael Nervoso - Piratas da Represa', },
            { src: './images/section/pda/12.jpg', caption: 'Pirata do Ano 2018 - Ruanitto Almeida - Piratas da Represa', },
            { src: './images/section/pda/13.jpg', caption: 'Pirata do Ano 2018 - Salviano da Silva Borges -  Confraria Jolly Roger ', },
            { src: './images/section/pda/14.jpg', caption: 'Pirata do Ano 2018 - Tia Mesk - RCC', },
        ],

        // FAQ
        faqQuestions: [
          {
            "perg": "COMO FUNCIONA?", "category": "",
            "resp": "Para quem não conhece a tradição do PIRATE DAY organizado pela ALIANÇA PIRATA, mais uma vez o evento será um piquenique, por isso sempre contamos com a colaboração de todos com os comes e bebes, tudo é colaborativo."
          },
          {
            "perg": "NÃO TENHO ROUPA DE PIRATA, E AGORA?", "category": "",
            "resp": "Não exigimos figurino, ou seja, é opcional ir caracterizado como pirata. Se você quiser estar caracterizado e não sabe como montar um figurino pirata, basta entrar NO GRUPO PIRATAS (facebook.com/groups/PiratasUrbanos) e pedir uma ajuda! Você também pode consultar nosso GUIA (pr8.com.br). É possível montar um figurino pirata a partir do que você já tem em casa. Outros figurinos de outros grupos são muito bem vindos também! Ninguém vai ligar se você vai de visual Steampunk, Medieval, Viking, Lolita, folk, qualquer um. Afinal pirata combina com tudo!"
          },
          {
            "perg": "EU PRECISO LEVAR ALGUMA COISA?", "category": "",
            "resp": "Já que é um piquenique, pedimos para todos levarem um prato de doce ou salgado (levem salgados também, suas formigas!!!) e uma bebida. Nós gostamos de comer nesses encontros, na verdade, gostamos de comer o tempo todo, por isso muita comida é sempre bem vinda! A comida nunca falta, na verdade sobra, mas não use isto como desculpa para não levar nada. Bebidas são bem vindas também, sucos, refrigerantes e água. Bebidas Alcoólicas como cerveja, rum, hidromel INFELIZMENTE não são permitidas pelo parque se estiverem em recipentes de vidro. Então, usen suas cabeças e bebam com responsabilidade e moderação. Se acha que vai passar dos limites e ficar de boas, lembre-se da música DRUNKEN SAILOR! Sugerimos também, que cada um leve sua caneca, horn, cranio, etc. para consumir suas bebidas, assim acumulamos a menor quantidade possivel de lixo."
          },
          {
            "perg": "COMO TUDO ISSO COMEÇOU?", "category": "",
            "resp": "O TALK LIKE A PIRATE DAY começou com uma brincadeira entre os americanos JOHN BAUR e MARK SUMMERS em 1995. Os dois jogavam raquetebol quando começaram com alguns xingamentos, afim de provocar um ao outro. Como (infelizmente) o vocabulário de palavrões da maioria das pessoas não é muito grande, em uma das jogadas, um deles ficou sem tempo de pensar em um palavrão a tempo e exclamou ARRR! Quando perceberam, estavam se xingando como piratas! Depois do jogo, passaram a treinar o vocabulário de pirata e acabaram criando um dia especial para tal acontecimento. Como no dia 6 de junho (dia que isto aconteceu) é comemorado o aniversário do Dia D da Segunda Guerra Mundial, resolveram mudar para dia 19 de Setembro, aniversário da ex-mulher de Mark. Aqui no BRASIL, o primeiro PIRATEDAY foi comemorado oficialmente (como evento aberto e sem fins lucrativos), em 2006, e em 2010 foi feito o primeiro PIRATEDAY pela ALIANÇA PIRATA."
          },
        ],
      }
    }
  }
</script>

<style lang="scss">
  /* CSS Reset */
  *, *:before, *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  *:focus {
    outline: none;
  }
  a, abbr, acronym, address, applet, article, aside, audio, b, big, blockquote, body, canvas, caption, center, cite, code, dd, del, details, dfn, div, dl, dt, em, embed, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, i, iframe, img, ins, kbd, label, legend, li, mark, menu, nav, object, ol, output, p, pre, q, ruby, s, samp, section, small, span, strike, strong, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, tt, u, ul, var, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
    margin: 0;
    padding: 0;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:after, blockquote:before, q:after, q:before {
    content: "";
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  
  @media (max-width: 1200px) {}
  @media (max-width: 992px) {}
  @media (max-width: 768px) {}
  @media (max-width: 576px) {}

  /* Fonts */
  @import url(https://fonts.googleapis.com/css?family=Gochi+Hand|Eagle+Lake);

  /* Sizes */
  $baseWidth: 1150px;

  /* Common Styles */
  body {
    overflow-x: hidden;
    height: 100%;
    min-height: 100%;
  }

    *, *:after, *:before {
    transition: all 0.5s ease;
  }
  a {
    cursor: pointer;
    text-decoration: none;
    
    &:hover {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
    }
  }

  ul {
    li {
      position: relative;
      padding-left: 30px;

      &:before {
        content: '☠';
        color: #990000;
        font-size: 15px;
        position: absolute;
        left: 5px;
        top: calc(50% + 3px);
        transform: translateY(-50%);
      }
    }
  }

  ul.li-col {
    li {
      padding: 15px 0 15px 30px;
      border-bottom: 1px solid #9F8253;
    }
  }

  .left, .right {
    max-width: calc(100% / 3);
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }

  .fb-blocks {
    display: flex;
    justify-items: center;
    .fb-block {
      width: 50% !important;

      span {
        width: 100% !important;

        iframe {
          width: 100% !important;
        }
      }
    }
  }

  .grad {
    background: #83F0FF;
    background: -moz-linear-gradient(top,  rgba(149,242,255,1) 0%, rgba(0,60,60,1) 100%);
    background: -webkit-linear-gradient(top,  rgba(149,242,255,1) 0%,rgba(0,60,60,1) 100%);
    background: linear-gradient(to bottom,  rgba(149,242,255,1) 0%,rgba(0,60,60,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff0000', endColorstr='#000000',GradientType=0 );

    display: block;
    width: 100%;
    height: 100%;
    min-height: 100%;
    padding-top: 150px;

    @media (max-width: 560px) {
      background: #000000;
    }
  }

  img {
    border: 10px solid #FFFFFF;
    margin: 15px;
  }

  .image-responsive {
    width: calc(100% - 30px);
  }

  /* Lightbox */
  .lightbox {
    &-overlay {
      z-index: 9999 !important;
      
      .holder {
        img {
          width: calc(100% - 30px) !important;
        }

        .nav {
          display: none !important;
        }
      }
    }

    &__container {
      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;

        li {
          width: calc(20% - 5px * 2);
          margin: 5px;
          border: 10px solid #FFFFFF;
          background: #000000;
          height: 110px;
          overflow: hidden;
          position: relative;
          cursor: zoom-in;

          img {
            width: 100%;
            margin: 0;
            border: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    &__container.pirata-do-ano {
      ul {
        li {
          height: 180px;
        }
      }
    }
  }

  /* Carousel */
  .VueCarousel {
    &-slide {
      height: 600px;

      @media (max-width: 1200px) {
        height: 500px;
      }
      @media (max-width: 992px) {
        height: 400px;
      }
      @media (max-width: 768px) {
        height: 300px;
      }
      @media (max-width: 576px) {
        height: 200px;
      }

      .slide__container {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;

        width: 100%;
        height: 100%;

        display: block;

        border: 0;
        margin: 0;
      }
    }
    &-wrapper {
      overflow: visible !important;

      height: 600px;
      
      @media (max-width: 1200px) {
        height: 500px;
      }
      @media (max-width: 992px) {
        height: 400px;
      }
      @media (max-width: 768px) {
        height: 300px;
      }
      @media (max-width: 576px) {
        height: 200px;
      }
    }
    &-navigation {
      &-button {
        background: url('././images/destaques/arrrrrow-hook.png') no-repeat;
        background-position: center center;
        background-color: rgba(255,255,255,.5) !important;

        outline: none !important;

        text-indent: -9999px;
        white-space: nowrap;
        overflow: hidden;

        width: 70px;
        height: 70px;

        padding: 10px !important;
        border-radius: 50%;

        @media (max-width: 1200px) {}
        @media (max-width: 992px) {}
        @media (max-width: 768px) {}
        @media (max-width: 576px) {
          display: none;
        }

        &:hover{
          background-color: rgba(255,255,255,0) !important;
        }
      }
      &-prev {
        left: 10vh !important;
        transform: rotate(-90deg) !important;

        &:hover {
          transform: rotate(-90deg) scale(1.2) !important;
        }
      }
      &-next {
        right: 10vh !important;
        transform: rotate(90deg) !important;

        &:hover {
          transform: rotate(90deg) scale(1.2) !important;
        }
      }
    }
    &-dot {
      background: url('././images/destaques/dots.png') no-repeat;
      background-position: center center;
      background-color: transparent !important;

      width: 30px !important;
      height: 30px !important;
      margin-top: 0 !important;

      outline: none !important;

      transform: scale(.7);

      &--active {
        background: url('././images/destaques/dots--active.png');
        background-position: center center;
        background-color: transparent !important;

        transform: scale(1);
      }

      &-container {
        margin-top: 5px !important;
      }
    }
  }
  .carousel {
    &__container {
      display: block;
      width: 100%;
      height: 600px;
      
      @media (max-width: 1200px) {
        height: 500px;
      }
      @media (max-width: 992px) {
        height: 400px;
      }
      @media (max-width: 768px) {
        height: 300px;
      }
      @media (max-width: 576px) {
        height: 200px;
      }
    }

    &__first {
      @extend .carousel__container;

      width: 100%;
      height: 600px;

      display: block;

      margin-top: 200px;

      position: relative;
      transform: rotate(-2deg) scale(1.05);

      @media (max-width: 1200px) {
        height: 500px;
      }
      @media (max-width: 992px) {
        height: 400px;
      }
      @media (max-width: 768px) {
        height: 300px;
      }
      @media (max-width: 576px) {
        height: 200px;
        margin-top: -50px;
        margin-bottom: 50px;
      }

      &:after {
        background: url('././images/destaques/rope-top.png');
        top: -20px;
      }
      &:before {
        background: url('././images/destaques/rope-bottom.png');
        bottom: -10px;
      }

      &:after, &:before {
        content: '';

        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;

        position: absolute;

        width: 100%;
        height: 25px;

        z-index: 10;
      }
    }
  }
</style>